var _rect, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftAngle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_85533",
    "data-name": "Group 85533",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.986,
    height: 44.987,
    viewBox: "0 0 44.986 44.987",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_637",
    "data-name": "Rectangle 637",
    width: 44.986,
    height: 44.987,
    transform: "translate(0 0)",
    fill: "#fff",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_85529",
    "data-name": "Group 85529",
    transform: "translate(8.444 8.341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85527",
    "data-name": "Group 85527",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_636",
    "data-name": "Rectangle 636",
    width: 28.097,
    height: 28.097,
    transform: "translate(0 0.115)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "next_1_",
    "data-name": "next (1)",
    transform: "translate(22.216 28.213) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85526",
    "data-name": "Group 85526",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109782",
    "data-name": "Path 109782",
    d: "M14.872,14.875,1.853,27.9A1.085,1.085,0,0,1,.318,26.361L12.572,14.107.318,1.853A1.085,1.085,0,0,1,1.853.318L14.872,13.34A1.085,1.085,0,0,1,14.872,14.875Z",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftAngle);
export default __webpack_public_path__ + "static/media/leftAngle.1c8feead5c1ba4038e3b7c1000aa653e.svg";
export { ForwardRef as ReactComponent };